import React, { useEffect, useState } from 'react';

import { useRouter } from 'next/router';
import Select from 'react-select';

import Style from '../Header.module.css';

import { citiesOptions } from '../../../../cities';
import { Button } from '../../../atoms';

import { durationOptions } from '../../../../constants';

function HeaderSearchMob({ handleSearch }) {
  const router = useRouter();
  const params = router?.query;
  const convertStringToObjArr = (val) => {
    const arrOfLocation = val.split(',');
    const arr = [];

    for (let i = 0; i < arrOfLocation.length; i++) {
      arr.push({ label: arrOfLocation[i], value: arrOfLocation[i] });
    }

    return arr;
  };

  const [jobTitle, setJobTitle] = useState(params?.jobTitle ? params?.jobTitle : '');
  const [skill, setSkill] = useState(params?.skill ? params?.skill : '');
  const [location, setLocation] = useState(params?.location ? convertStringToObjArr(params?.location) : '');
  const [duration, setDuration] = useState(params?.duration ? durationOptions?.find((ele) => ele?.value == params?.duration) : '');
  const [show, setShow] = useState(false);

  const inputStyles = {
    control: (base) => ({
      ...base,
      padding: '1px ',
      color: '#3c4858',
      fontWeight: '400',
      border: 'none',
      boxShadow: 'none',
      display: 'flex',
      borderRadius: '5px',
      width: '100%',
      backgroundColor: '#FFFFFF',
      fontSize: '16px',
      lineHeight: '20px'
    }),
    menu: (base) => ({
      ...base,
      color: '#000000',
      fontSize: '16px',
      lineHeight: '20px',
      zIndex: '2000'
    }),
    ValueContainer: (base) => ({
      ...base,
      padding: '0'
    })
  };

  const handleSearchClick = (event) => {
    event.preventDefault();
    handleSearch({
      jobTitle,
      skill,
      location,
      duration
    });
  };

  useEffect(() => {
    if (!show) {
      if (jobTitle.length !== 0) {
        setShow(true);
      }
    }
  }, [jobTitle]);

  useEffect(() => {
    if (show) {
      if (jobTitle?.length === 0 && skill?.length === 0 && location?.length === 0) {
        setShow(false);
      }
    }
  }, [jobTitle, skill]);

  return (
    <form className='border-bottom-solid-gray-4' onSubmit={(e) => handleSearchClick(e)}>
      <div className='flexStyleStart padding15'>
        <div className={!show ? `${Style.searchInputBox}` : `${Style.searchInputBox} full-width-imp margin-0`}>
          <input
            onChange={(e) => {
              setJobTitle(e.target.value);
            }}
            placeholder={show ? 'Job title' : 'Search Jobs'}
            value={jobTitle}
          />
        </div>
        <div className={!show ? `${Style.searchBtn} center-x-y` : 'visually-hidden'} onClick={() => setShow(true)}>
          <img height={24} src='/images/homepage/search-white.svg' width={24} />
        </div>
      </div>
      <div className={!show ? 'visually-hidden' : 'padding15 padding0T'}>
        <div className={`${Style.searchInputBox} full-width-imp`}>
          <input
            onChange={(e) => {
              setSkill(e.target.value);
            }}
            placeholder='Skill'
            value={skill}
          />
        </div>
      </div>
      <div className={!show ? 'visually-hidden' : 'padding15 padding0T'}>
        <div className={`${Style.searchInputBox} full-width-imp padding0T padding0B`}>
          <Select
            id='location'
            isMulti={true}
            isOptionDisabled={() => location?.length >= 5}
            menuPosition='fixed'
            name='location'
            onChange={setLocation}
            options={citiesOptions}
            placeholder='Location'
            styles={inputStyles}
            value={location}
          />
        </div>
      </div>
      <div className={!show ? 'visually-hidden' : 'padding15 padding0T'}>
        <div className={`${Style.searchInputBox} full-width-imp padding0T padding0B`}>
          <Select
            id='duration'
            isMulti={false}
            menuPosition='fixed'
            name='duration'
            onChange={setDuration}
            options={durationOptions}
            placeholder='Duration'
            styles={inputStyles}
            value={duration}
          />
        </div>
      </div>
      <div className={!show ? 'visually-hidden' : 'padding15 padding0T'}>
        <Button className='general-style-2 save-and-exit-button' type='submit'>
          Search
        </Button>
      </div>
    </form>
  );
}

export default HeaderSearchMob;
